import { sections } from '../content/sections'

/**
 * Renders the sticky sidebar navigation with section links.
 */
export function renderNav(): string {
  const items = sections
    .map(
      (s, i) =>
        `<li class="nav-list__item">
          <a href="#${s.id}" class="nav-list__link" data-nav-link="${s.id}">
            <span class="nav-list__num">${String(i + 1).padStart(2, '0')}</span>
            ${s.title}
          </a>
        </li>`
    )
    .join('')

  return `<nav class="sidebar" id="sidebar" aria-label="Documentation sections">
    <ul class="nav-list">${items}</ul>
  </nav>`
}

/**
 * Wires mobile drawer toggle, overlay, and scroll-spy active states.
 */
export function initNav(): void {
  const toggle = document.getElementById('nav-toggle')
  const sidebar = document.getElementById('sidebar')
  const overlay = document.getElementById('sidebar-overlay')
  const links = document.querySelectorAll<HTMLAnchorElement>('[data-nav-link]')

  const closeDrawer = (): void => {
    sidebar?.classList.remove('is-open')
    overlay?.classList.remove('is-visible')
    toggle?.setAttribute('aria-expanded', 'false')
  }

  toggle?.addEventListener('click', () => {
    const isOpen = sidebar?.classList.toggle('is-open')
    overlay?.classList.toggle('is-visible', Boolean(isOpen))
    toggle.setAttribute('aria-expanded', String(Boolean(isOpen)))
  })

  overlay?.addEventListener('click', closeDrawer)

  links.forEach((link) => {
    link.addEventListener('click', closeDrawer)
  })

  const sectionEls = sections
    .map((s) => document.getElementById(s.id))
    .filter((el): el is HTMLElement => el !== null)

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          const id = entry.target.id
          links.forEach((link) => {
            link.classList.toggle('is-active', link.dataset.navLink === id)
          })
        }
      })
    },
    { rootMargin: '-30% 0px -60% 0px', threshold: 0 }
  )

  sectionEls.forEach((el) => observer.observe(el))
}
